@if (isCreateUpdateRemoveAccess) {
  <div class="row">
    <div class="col">
      <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#createBrandModal">
        Create
      </button>
    </div>
  </div>
}

<div class="table-responsive mt-2">
  <table class="table">
    <thead>
      <tr>
        <th>SrNo</th>
        <th>Name</th>
        <th>Brand ID</th>
        <th>Description</th>
        @if (isCreateUpdateRemoveAccess) {
          <th></th>
        }
      </tr>
    </thead>
    <tbody>
      @for (data of brandList | paginate
        : {
        itemsPerPage: pageSize,
        currentPage: page + 1,
        totalItems: allTotal
        }; track data) {
        <tr>
          <td>{{data.srNo}}</td>
          <td>{{data.name}}</td>
          <td>{{data.sapBrandId}}</td>
          <td>{{data.description}}</td>
          @if (isCreateUpdateRemoveAccess) {
            <td>
              <div style="text-align: right">
                <button type="button" class="btn btn-primary" (click)="openUpdateModel(data)">Update</button>
                <button type="button" class="btn btn-danger ml-3" (click)="removeBrand(data.name)">
                  @if (isUploading) {
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  }
                  @if (!isUploading) {
                    <span>Remove</span>
                  }
                </button>
              </div>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>

<div style="text-align: center">
  <pagination-controls [maxSize]="20" previousLabel="Prev" nextLabel="Next" [responsive]="true"
  (pageChange)="handlePageChange($event)"></pagination-controls>
</div>
@if (loading) {
  <div class="loading d-flex justify-content-center">
    <div class="spinner-border text-primary" role="status"></div>
  </div>
}

<!-- Create Brand Model -->
<div class="modal" id="createBrandModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Create Brand</h5>
      </div>
      <div class="modal-body">
        <form [formGroup]="createBrandForm">
          <div class="mb-3">
            <label class="form-label">Name</label>
            <input type="text" class="form-control" formControlName="name">
          </div>
          <div class="mb-3">
            <label class="form-label">Description</label>
            <input type="text" class="form-control" formControlName="description">
          </div>
          <div class="mb-3">
            <label class="form-label">Brand ID</label>
            <input type="text" class="form-control" formControlName="sapBrandId">
          </div>
        </form>
        @if (isError) {
          <div>
            <div class="alert alert-danger" role="alert">{{ errorMessage }}</div>
          </div>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" (click)="createBrand()"
          [disabled]="!createBrandForm.valid">
          @if (isUploading) {
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          }
          @if (!isUploading) {
            <span>Submit</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Update Brand Model -->
<div class="modal" tabindex="-1" [ngStyle]="{ display: displayStyle }" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Update Brand</h5>
      </div>
      <div class="modal-body">
        <form [formGroup]="updateBrandForm">
          <div class="mb-3">
            <label class="form-label">Description</label>
            <input type="text" class="form-control" formControlName="description">
          </div>
          <div class="mb-3">
            <label class="form-label">Brand ID</label>
            <input type="text" class="form-control" formControlName="sapBrandId">
          </div>
        </form>
        @if (isError) {
          <div>
            <div class="alert alert-danger" role="alert">{{ errorMessage }}</div>
          </div>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModel()">Close</button>
        <button type="button" class="btn btn-primary" (click)="updateBrand()"
          [disabled]="!updateBrandForm.valid">
          @if (isUploading) {
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          }
          @if (!isUploading) {
            <span>Submit</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>

